import { extendTheme } from '@chakra-ui/react';

/**
 * Default theme configuration
 * Used as fallback when no brand-specific theme is available
 * @deprecated Use DynamicThemeProvider and themeManager instead
 */
export const theme = extendTheme({
    colors: {
        primary: {
            50: '#e1f0fa',
            100: '#b3daf3',
            200: '#80c2ec',
            300: '#4da9e4',
            400: '#2695df',
            500: '#0582CA',
            600: '#0574b3',
            700: '#04619a',
            800: '#044e81',
            900: '#03395e',
        },
        secondary: {
            50: '#fff4e1',
            100: '#ffe5b3',
            200: '#ffd580',
            300: '#ffc54d',
            400: '#ffb926',
            500: '#FFAD05',
            600: '#e69c05',
            700: '#cc8904',
            800: '#b37504',
            900: '#8f5a03',
        },
        tertiary: {
            50: '#ffe1ec',
            100: '#ffb3cf',
            200: '#ff80ae',
            300: '#ff4d8c',
            400: '#ff2673',
            500: '#ff007f',
            600: '#e60071',
            700: '#cc0062',
            800: '#b30054',
            900: '#8f0040',
        },
        screen: '#F6F7F8',
    },
    fonts: {
        heading: `'Inter Variable', sans-serif`,
        body: `'Outfit Variable', sans-serif`,
    },
    config: {
        initialColorMode: 'light',
        useSystemColorMode: false,
        disableTransitionOnChange: false,
    },
    styles: {
        global: () => ({
            'html, body': {
                backgroundColor: '#F7FAFC',
                userSelect: 'none',
                touchAction: 'manipulation',
            },
        }),
    },
});
